import './styles.scoped.css'
import {useEffect, useState} from 'react'
import {useAuth} from '../../contexts/AuthContext'
import {Button, Typography, IconButton} from '@mui/material'
import {Close} from '@mui/icons-material'
import {careviahLogo, welcome} from '../../assets'
import {useNavigate} from 'react-router-dom'
import {accountApi} from '../../services'
import {useGlobalStates} from '../../contexts/GlobalStatesContext'
import {parseError} from '../../utils/helpers'
import {googlePlay, appStore} from '../../assets'
import axios from 'axios'

export default () => {
    const {setAccount, account, user, roles} = useAuth()
    const navigate = useNavigate()
    const {setLoading, setMessageBox} = useGlobalStates()
    const [isCaregiver, setIsCaregiver] = useState(false)

    useEffect(() => {
        ;(async () => {
            if (account?.show_welcome) {
                try {
                    setLoading(true)
                    await accountApi.welcomeAcknowledge()
                    const {
                        data: {data},
                    } = await accountApi.getAccount()
                    setLoading(false)
                    setAccount(data)
                } catch (error) {
                    setLoading(false)
                    const {title, description} = parseError(error)
                    if (description) {
                        setMessageBox({status: 'error', title, description})
                    }
                }
            } else if (!roles?.includes('caregiver')) {
                navigate('/')
            }
        })()
    }, [])

    useEffect(() => {
        if (roles?.includes('caregiver')) {
            setIsCaregiver(true)
        } else {
            setIsCaregiver(false)
        }
    }, [roles])

    const close = async () => {
        setLoading(true)
        try {
            const response = await axios.post(
                '/auth/logout',
                {},
                {
                    withCredentials: true,
                    headers: {'Content-Type': 'application/json'},
                },
            )
            setLoading(false)
            setAccount(null)
            if (response?.data?.logout_url) {
                window.location.href = response?.data?.logout_url
            } else {
                window.location.href = '/login'
            }
        } catch (error) {
            setLoading(false)
            setAccount(null)
            window.location.href = '/login'
        }
    }

    return (
        <div className="container">
            <img src={careviahLogo} width={264} />
            <br />
            <br />
            <img src={welcome} />
            <br />
            <br />
            <Typography variant="h5" color="primary">
                Welcome, {user?.first_name}!
            </Typography>
            <br />
            <br />
            <Typography variant="body1" color="text.primary">
                Your account has been created successfully.
            </Typography>
            {isCaregiver ? (
                <>
                    <br />
                    <br />
                    <Typography variant="body1" color="text.primary">
                        1. Please install a Careviah Caregiver app
                    </Typography>
                    <br />
                    <div className="install">
                        <img src={googlePlay} />
                        <img src={appStore} />
                    </div>
                    <br />
                    <Typography variant="body1" color="text.primary">
                        2. Sign in with your email <b style={{color: '#0D5D59'}}>{user?.email}</b>
                    </Typography>
                    <IconButton className="close" onClick={close}>
                        <Close />
                    </IconButton>
                </>
            ) : (
                <>
                    <Typography variant="body1" color="text.primary">
                        You can now log in and start using Careviah.
                    </Typography>
                    <br />
                    <Button variant="contained" onClick={() => navigate('/')}>
                        Go to Dashboard
                    </Button>
                </>
            )}
        </div>
    )
}
